/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "../actions/actionTypes";

// initialState
const initialState = {
  todaysGeometry: [],
  filteredGeometry: [],
};

/**
 * Capture actions dispatched and modify state accordingly
 * @param {*} state -> updated state
 * @param {*} action -> type of action dispatched
 */
const geofence = (state = initialState, action) => {
  switch (action.type) {
    // clear todays fetched geometry
    case actionTypes.CLEAR_TODAYS_GEOMETRY:
      return {
        ...state,
        todaysGeometry: [],
      };

    // clear filtered(by date in replay coordinates date selector) geometry
    case actionTypes.CLEAR_FILTERED_GEOMETRY:
      return {
        ...state,
        filteredGeometry: [],
      };

    // set todays fetched geometry
    case actionTypes.SET_TODAYS_GEOMETRY:
      return {
        ...state,
        todaysGeometry: state.todaysGeometry.concat(action.data),
      };

    // set filtered(by date in replay coordinates date selector) geometry
    case actionTypes.SET_FILTERED_GEOMETRY:
      return {
        ...state,
        filteredGeometry: state.filteredGeometry.concat(action.data),
      };

    default:
      return state;
  }
};

export default geofence;
